import { TableColumnMeta } from "ds/components/Table/types";

export const BACKSTAGE_TABLE_STORAGE_KEY = "backstage-integrations-table";
export const FILTERS_ORDER_SETTINGS_KEY = "backstageFiltersOrder";

export enum BACKSTAGE_COLUMN_ID {
  NAME = "NAME",
  SPACE = "SPACE",
  DESCRIPTION = "DESCRIPTION",
  DROPDOWN = "DROPDOWN",
}

const MAX_CELL_WIDTH = 2000;

export const BACKSTAGE_TABLE_COLUMNS_CONFIG: Record<BACKSTAGE_COLUMN_ID, TableColumnMeta> = {
  [BACKSTAGE_COLUMN_ID.NAME]: {
    id: BACKSTAGE_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 120,
    defaultWidth: 120,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [BACKSTAGE_COLUMN_ID.SPACE]: {
    id: BACKSTAGE_COLUMN_ID.SPACE,
    title: "Space",
    minWidth: 112,
    defaultWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [BACKSTAGE_COLUMN_ID.DESCRIPTION]: {
    id: BACKSTAGE_COLUMN_ID.DESCRIPTION,
    title: "Description",
    minWidth: 130,
    defaultWidth: 240,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: false,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [BACKSTAGE_COLUMN_ID.DROPDOWN]: {
    id: BACKSTAGE_COLUMN_ID.DROPDOWN,
    title: "Integration actions",
    noHeader: true,
    maxWidth: 60,
    minWidth: 60,
    defaultWidth: 60,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    configurable: false,
    canPin: false,
    canMove: false,
  },
};

export const SORT_CONFIG: Record<BACKSTAGE_COLUMN_ID, string> = {
  [BACKSTAGE_COLUMN_ID.NAME]: "name",
  [BACKSTAGE_COLUMN_ID.SPACE]: "space",
  [BACKSTAGE_COLUMN_ID.DESCRIPTION]: "description",
  [BACKSTAGE_COLUMN_ID.DROPDOWN]: "dropdown",
};
